import ArrangePuzzleGame from './ArrangePuzzleGame';
import TigerImage from '../../assets/tiger.avif';

export default function TigerPuzzle() {
  return <ArrangePuzzleGame imageSrc={TigerImage} gameId="tigerImagePuzzle" />;
}
